/* @flow */
let configFromWindowObject = {}
try {
  configFromWindowObject = JSON.parse(window.GR_CONFIG)
} catch (err) { }

const getValue = (key: string) => {
  return configFromWindowObject[key] || process.env[key] || ''
}

const config = {
  INTERCOM_APP_ID: getValue('REACT_APP_INTERCOM_APP_ID'),
  MIXPANEL_TOKEN: getValue('REACT_APP_MIXPANEL_TOKEN'),
  AUTH0_CUSTOM_DOMAIN: getValue('REACT_APP_AUTH0_CUSTOM_DOMAIN'),
  AUTH0_DOMAIN: getValue('REACT_APP_AUTH0_DOMAIN'),
  AUTH0_CLIENT_ID: getValue('REACT_APP_AUTH0_CLIENT_ID'),
  AUTH0_CALLBACK_URL: getValue('REACT_APP_AUTH0_CALLBACK_URL'),
  BASE_URL_RECURLY: getValue('REACT_APP_BASE_URL_RECURLY'),
  // Stripe payment links (public addresses, not secrets). While a link is empty
  // the player still sends that plan to Recurly.
  STRIPE_LINKS: {
    'gymradio-pro': getValue('REACT_APP_STRIPE_LINK_MONTHLY') || 'https://buy.stripe.com/8x26oH89T8HH27seqhgA801',
    'gymradio-pro-year': getValue('REACT_APP_STRIPE_LINK_YEARLY') || 'https://buy.stripe.com/5kQ5kD61L1ffcM681TgA802'
  },
  // One "manage my billing" page for every gym (Stripe customer portal login link)
  STRIPE_PORTAL: getValue('REACT_APP_STRIPE_PORTAL') || 'https://billing.stripe.com/p/login/bJe00j4XHe218vQaa1gA800',
  BASE_URL_WEB: getValue('REACT_APP_BASE_URL_WEB'),
  BASE_URL_API: getValue('REACT_APP_BASE_URL_API'),
  BASE_URL_EVENT_API: getValue('REACT_APP_BASE_URL_EVENT_API')
}

export default config
